import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getInvoice(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams);
}

export async function createInvoice(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/invoice" + pathname, body);
}

export async function updateSalesRecap(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/invoice" + pathname, body);
}

export async function updateInvoice(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/invoice" + pathname, body);
}

export async function deleteInvoice(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/invoice" + pathname + queryParams);
}
